import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  RadioButtonGroup,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Layer,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Video,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { callApiGetJson, callApiPostJson } from "./GlobalSettings";
import auth from "./Security/Auth";

class UserInfo extends Component {
  constructor(props) {
    super(props);

    console.log("*Props reached UserInfo***", this.props.UserDets);

    this.state = {
      bdisp: this.props.display,
      bdisabled: true,
      UserInfo: this.props.UserDets,
      TimeZoneData: undefined,
      RegionData: undefined,
      JobRoleData: undefined,
      JobLevelData: undefined,
      CountryData: undefined,
      LocationData: undefined,
      finished: false,
      stepIndex: 0,
      emailAddress: auth.getUserEmail(),
      usrimg: undefined,
      companyValue: this.props.UserDets.Company,
      countryvalue: "India",
      locationID: 100,
      regionValue: undefined,
      timezoneValue: auth.getUserInfo().TimeZone //this.state.UserInfo.TimeZone
        ? auth.getUserInfo().TimeZone.Timezone_ID //this.state.UserInfo.TimeZone.Timezone_ID
        : undefined,
      jobRoleValue: this.props.UserDets.Job,
      locationValue: undefined,
      jobLevelValue: undefined,
      learnerValue: this.props.UserDets.LearnerID,
      nextClicked: false,
      locationID: undefined,
      submitClicked: false,
      showLoader: false,
      nl_sub: true,
      user_sub: auth.getUserInfo().IsNL_Subscribed ? "Yes" : "No",
      RegionSelect: [],
    };

    this.loadTimeZoneData = this.loadTimeZoneData.bind(this);
    this.loadRegionData = this.loadRegionData.bind(this);
    this.loadLocationData = this.loadLocationData.bind(this);
    //this.loadJobRoleData =this.loadJobRoleData.bind(this);
    this.loadJobLevelData = this.loadJobLevelData.bind(this);
    this.loadCountryData = this.loadCountryData.bind(this);
    this.handleCompany = this.handleCompany.bind(this);
    this.handleNLSub = this.handleNLSub.bind(this);
    // this.handleRegion = this.handleRegion.bind(this);
    this.handleCountry = this.handleCountry.bind(this);
    this.handleTimeZone = this.handleTimeZone.bind(this);
    this.handleJob = this.handleJob.bind(this);
    this.handleLearner = this.handleLearner.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkForLearnerId = this.checkForLearnerId.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
  }

  componentDidMount() {
    console.log("**From UserInfo ", this.props.display);
    console.log("From User Info User Dets via Props ", this.props.UserDets);
    console.log("**From Component Mount of ", this.state.UserInfo);
    console.log("**From Component Mount via AuthJs ", auth.getUserInfo());

    //this.setState({ UserInfo: auth.getUserInfo() });

    this.loadTimeZoneData();
    this.loadRegionData();
    // this.loadJobRoleData();
    this.loadJobLevelData();
    this.loadCountryData();
    this.loadLocationData();
    console.log("** LocationData Captured From API");
    console.log(this.state.LocationData);

    if (this.state.UserInfo) {
      this.setState({
        companyValue: auth.getUserInfo().Company, //this.state.UserInfo.Company,
        countryvalue: auth.getUserInfo().UserLocation.Country, //this.state.UserInfo.UserLocation.Country
        jobvalue: auth.getUserInfo().UserExpertise.ExpertLevelName, //this.state.UserInfo.UserExpertise.ExpertLevelName,
        usrimg: this.state.UserInfo.UsrImgData,
        regionValue: auth.getUserInfo().UserLocation //this.state.UserInfo.UserLocation
          ? auth.getUserInfo().UserLocation.Region //this.state.UserInfo.UserLocation.Region
          : undefined,
        timezoneValue: auth.getUserInfo().TimeZone //this.state.UserInfo.TimeZone
          ? auth.getUserInfo().TimeZone.Timezone_ID //this.state.UserInfo.TimeZone.Timezone_ID
          : undefined,
        //jobRoleValue: (this.state.UserInfo.UserJob ? this.state.UserInfo.UserJob.JobID: undefined),
        jobRoleValue: auth.getUserInfo().Job, //this.state.UserInfo.Job,
        locationValue: auth.getUserInfo().UserLocation //this.state.UserInfo.UserLocation
          ? auth.getUserInfo().UserLocation.Country //this.state.UserInfo.UserLocation.Country
          : undefined,
        jobLevelValue: auth.getUserInfo().UserExpertise //this.state.UserInfo.UserExpertise
          ? auth.getUserInfo().UserExpertise.ExpertLevelID //this.state.UserInfo.UserExpertise.ExpertLevelID
          : undefined,
        learnerValue: auth.getUserInfo().LearnerID, //this.state.UserInfo.LearnerID,
        locationID: auth.getUserInfo().UserLocation //this.state.UserInfo.UserLocation
          ? auth.getUserInfo().UserLocation.LocationID //this.state.UserInfo.UserLocation.LocationID
          : undefined,
        nl_sub: auth.getUserInfo().IsNL_Subscribed,
      });
      if (!auth.getUserInfo().LearnerID) {
        this.checkForLearnerId();
      }
    }
  }

  checkForLearnerId() {
    var endpoint = "/Account/FindLearnerID";
    let token = auth.getToken();
    var postData = {
      UserType: this.state.UserInfo.UserTypeID,
      UserEmail: this.state.UserInfo.EmailAddress,
    };

    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("learner ID data from API:", data);
      if (data) {
        console.log("Learner ID data: ");
        this.setState({ learnerValue: data[0] });
      }
    });
  }

  loadTimeZoneData() {
    var endpoint = "/Metadata/GetTimezones";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("TimeZone data from API:", data);
      this.setState({
        TimeZoneData: data,
      });
    });
  }

  loadRegionData() {
    var endpoint = "/Metadata/GetRegions";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Region data from API:", data);
      this.setState({
        RegionData: data,
      });
    });
  }

  handleEditClick = () => {
    this.setState({ bdisabled: false });
  };

  loadLocationData() {
    var endpoint = "/Metadata/GetLocations";
    let token = auth.getToken();
    console.log(auth.getToken());
    let locData = [];
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Locations from API:", data);
      locData.push(data[0]);
      var AllCountriesList = [];
      data.forEach(function (item, index) {
        console.log(item);
        AllCountriesList = AllCountriesList.concat(item.LstCountryVM);
      });

      var sort_by = function (field, reverse, primer) {
        var key = primer
          ? function (x) {
              return primer(x[field]);
            }
          : function (x) {
              return x[field];
            };

        reverse = !reverse ? 1 : -1;

        return function (a, b) {
          return (a = key(a)), (b = key(b)), reverse * ((a > b) - (b > a));
        };
      };
      console.log(AllCountriesList);
      AllCountriesList.sort(
        sort_by("Country", false, function (a) {
          return a.toUpperCase();
        })
      );
      console.log(AllCountriesList);
      this.setState({
        LocationData: data,
        RegionSelect: locData,
        CountriesList: AllCountriesList,
      });
    });
  }

  loadJobLevelData() {
    var endpoint = "/Metadata/GetExpertLevels";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Job Level data from API:", data);
      this.setState({
        JobLevelData: data,
      });
    });
  }

  loadCountryData() {
    var endpoint = "/Metadata/GetCountries";
    let token = auth.getToken();
    console.log(auth.getToken());
    callApiGetJson(endpoint, token).then((data) => {
      console.log("Country data from API:", data);
      this.setState({
        CountryData: data,
      });
    });
  }

  handleNLSub(value) {
    console.log("Handle Sub Clicked with value ", value);
    if (value === "Yes") {
      this.setState({ user_sub: value, nl_sub: true });
    } else {
      this.setState({ user_sub: value, nl_sub: false });
    }
  }

  handleCompany(value) {
    console.log("Company Changed with value ", value);
    this.setState({ companyValue: value });
  }

  handleCountry(value) {
    let locationID;
    console.log("**HandleCountry Clicked with selection below");
    console.log(value);
    console.log("**AllListOf Countries below");
    console.log(this.state.CountriesList);

    this.state.CountriesList.map((country) => {
      console.log(country);
      if (country.Country == value) {
        locationID = country.LocationID;
        console.log("Value Matched");
        console.log(country);
        console.log(country.LocationID);
        console.log(locationID);
        this.setState({ countryvalue: value, locationID: locationID });
        /*         this.setState({countryvalue : value});
        this.setState({locationID : locationID}); */
      }
    });
  }

  handleSubmit = () => {
    //alert("Submitted");
    /*     const {
      jobRoleValue,
      locationID,
      jobLevelValue,
      companyValue,
      timezoneValue,
      learnerValue,
    } = this.state; */
    //if (this.state.jobRoleValue) {
    //console.log("**Job Role Value is ", this.state.jobRoleValue);
    var profileData = {
      EmailAddress: this.state.emailAddress,
      Company: this.state.companyValue, //companyValue
      TimeZone: { Timezone_ID: this.state.timezoneValue },
      LearnerID: this.state.learnerValue,
      IsNL_Subscribed: this.state.nl_sub,
      Job: this.state.jobRoleValue, // this.state.jobRoleValue,
      /* "Job": {
              "JobID": jobRoleValue
          },*/
      UserLocation: {
        LocationID: this.state.locationID,
      },
    };
    var endpoint = "/Account/UpdateUserProfile";
    let token = auth.getToken();
    var postData = profileData;
    console.log("Profile request data for user Update :", profileData);
    this.setState({ showLoader: true });
    //start below
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("Profile result data from API:", data);
      if (data) {
        console.log("UpdateMessage: ");
        console.log(data.UpdateMessage);

        auth.updateUserInfo(data);
        this.props.hide();
        // this.props.history.push("/home");
        //this.props.router.replace("/home");
      }
    });
    // end above
    //}
    /* else {
      this.setState({ submitClicked: true });
    } */
  };

  handleTimeZone(value) {
    if (this.state.TimeZoneData) {
      this.state.TimeZoneData.map((tz) => {
        if (tz.Timezone_Name === value) {
          this.setState({ timezoneValue: tz.Timezone_ID });
        }
      });
    }
  }

  handleJob(value) {
    console.log("** Job text provided as ", value);
    this.setState({ jobRoleValue: value });
  }

  handleLevel(value) {
    let ExpertiseID;
    console.log("**Handle Job or Expertise Clicked with selection below");
    console.log(value);
    console.log("**AllListOf Expertises below");
    console.log(this.state.JobLevelData);

    this.state.JobLevelData.map((job) => {
      console.log(job);
      if (job.ExpertLevelName == value) {
        ExpertiseID = job.ExpertLevelID;
        console.log("Value Matched");
        console.log(job);
        console.log(job.ExpertLevelID);
        console.log(ExpertiseID);
        this.setState({ jobLevelValue: ExpertiseID });
      }
    });
  }
  handleLearner(value) {
    console.log("Learner ID Changed with value ", value);
    this.setState({ learnerValue: value });
  }

  render() {
    var FName = this.state.UserInfo.FirstName;
    var LName = this.state.UserInfo.LastName;
    var email = this.state.emailAddress;
    var company = this.state.companyValue; //this.state.UserInfo.Company;
    var Job = this.state.jobRoleValue; //this.state.UserInfo.Job;
    var LearnerID = this.state.learnerValue; //this.state.UserInfo.LearnerID;
    var countList = new Array();
    var TimezoneList = new Array();
    var isdisabled = this.state.bdisabled;
    var user_sub = this.state.user_sub;

    var TzVal_Id = undefined;

    if (this.state.TimeZoneData && this.state.timezoneValue) {
      this.state.TimeZoneData.map((tzdata) => {
        if (tzdata.Timezone_ID === this.state.timezoneValue) {
          TzVal_Id = tzdata.Timezone_Name;
        }
      });
    }

    if (this.state.CountriesList) {
      this.state.CountriesList.map((country) => {
        countList.push(country.Country);
      });
      console.log("**CountryList After**");
      console.log(countList);
    }

    if (this.state.TimeZoneData) {
      //var TimezList = new Array();
      this.state.TimeZoneData.map((tz) => {
        TimezoneList.push(tz.Timezone_Name);
      });
    }

    /*  if (this.state.UserInfo.IsNL_Subscribed) {
      user_sub = "Yes";
    } */

    return (
      <Layer
        //full="vertical"
        position="center"
        height="medium"
        onClickOutside={this.props.hide}
        onEsc={this.props.hide}
      >
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                gap="medium"
                basis="xlarge"
                direction="column"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/* <Button label="Home" icon={<FormPrevious />} /> */}
                  <Heading margin="none">My Profile</Heading>
                </Header>
                {/*  <marquee>
                  Press ESC key or Click outside to return to Home Page
                </marquee> */}
                <Box
                  align="center"
                  justify="center"
                  direction="row"
                  gap="xsmall"
                >
                  <Button
                    label="Edit"
                    size="large"
                    secondary
                    onClick={this.handleEditClick}
                  />
                  <Button
                    label={
                      this.state.showLoader ? (
                        <Box
                          direction="row"
                          gap="small"
                          justify="center"
                          align="center"
                        >
                          <Spinner size="small" color="brand" />{" "}
                          <Text>Saving User Info..</Text>
                        </Box>
                      ) : (
                        "Save User Info."
                      )
                    }
                    size="large"
                    secondary
                    onClick={this.handleSubmit}
                    disabled={isdisabled}
                  />
                </Box>
                <Box
                  align="stretch"
                  justify="center"
                  background={{ color: "background-front" }}
                  pad="medium"
                  gap="small"
                >
                  <Grid columns={["small", "medium"]}>
                    <Text size="medium">First Name</Text>
                    <TextInput
                      value={FName}
                      type="text"
                      plain={false}
                      disabled={true}
                      size="medium"
                    />
                    <Text>Last Name</Text>
                    <TextInput
                      value={LName}
                      type="text"
                      plain={false}
                      disabled={true}
                      size="medium"
                    />
                    <Text>Email</Text>
                    <TextInput
                      value={email}
                      type="text"
                      plain={false}
                      disabled={true}
                      size="medium"
                    />
                    <Text>Company</Text>
                    <TextInput
                      value={this.state.companyValue}
                      type="text"
                      plain={false}
                      disabled={isdisabled}
                      onChange={(event) =>
                        this.handleCompany(event.target.value)
                      }
                      size="medium"
                    />
                    <Text>Job Role</Text>
                    <TextInput
                      value={this.state.jobRoleValue}
                      type="text"
                      plain={false}
                      disabled={isdisabled}
                      onChange={(event) => this.handleJob(event.target.value)}
                      size="medium"
                    />
                    <Text>Learner ID</Text>
                    <TextInput
                      value={this.state.learnerValue}
                      type="text"
                      plain={false}
                      disabled={isdisabled}
                      onChange={(event) =>
                        this.handleLearner(event.target.value)
                      }
                      size="medium"
                    />
                    <Text>Country</Text>
                    <SingleSelect
                      value={this.state.countryvalue}
                      placeholder="Select your Country"
                      options={countList}
                      disabled={isdisabled}
                      onChange={this.handleCountry}
                    />

                    <Text>TimeZone</Text>
                    <SingleSelect
                      value={TzVal_Id} //{this.state.timezoneValue}
                      placeholder="Select your Timezone"
                      options={TimezoneList}
                      disabled={isdisabled}
                      onChange={this.handleTimeZone}
                    />

                    {/*                     <Text>Expertise Level</Text>
                    <TextInput
                      value="This is wrong placeholder need to change to dropdown"
                      type="text"
                      plain={false}
                      size="medium"
                    /> */}
                    <mark>
                      <Text>Newsletter subscription</Text>
                    </mark>
                    <RadioButtonGroup
                      options={["Yes", "No"]}
                      value={user_sub}
                      direction="row"
                      onChange={(event) => this.handleNLSub(event.target.value)}
                      disabled={isdisabled}
                    />
                  </Grid>
                </Box>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}

export default withRouter(UserInfo);
